/* JOBS */
export const GET_ACTIVITY_LOGS = "GET_ACTIVITY_LOGS"
export const GET_ACTIVITY_LOGS_SUCCESS = "GET_ACTIVITY_LOGS_SUCCESS"
export const GET_ACTIVITY_LOGS_FAIL = "GET_ACTIVITY_LOGS_FAIL"

/* JOBS DETAIL*/
export const GET_ACTIVITY_LOG_DETAIL = "GET_ACTIVITY_LOG_DETAIL"
export const GET_ACTIVITY_LOG_DETAIL_SUCCESS = "GET_ACTIVITY_LOG_DETAIL_SUCCESS"
export const GET_ACTIVITY_LOG_DETAIL_FAIL = "GET_ACTIVITY_LOG_DETAIL_FAIL"
